import { ModerationDecision, ModerationFieldType } from '../../domain/models/Moderation';
import { ModerationRepository } from '../../domain/repositories/ModerationRepository';
import { ModerationDataSource } from '../datasources/ModerationDataSource';

export class ModerationRepositoryImpl implements ModerationRepository {
  constructor(private dataSource: ModerationDataSource) {}

  async moderate(params: {
    text?: string;
    imageUrl?: string;
    fieldType: ModerationFieldType;
    userId: string;
  }): Promise<ModerationDecision> {
    const response = await this.dataSource.moderate(params);
    return {
      action: response.action,
      reasons: response.reasons,
    };
  }
}
